'use client';

import React from 'react';
import Link from 'next/link';

export default function FooterSection() {
  return (
    <footer id="footer" className="footer dark-background">
      <div className="footer-top">
        <div className="container">
          <div className="row gy-4">
            {/* Footer About */}
            <div className="col-lg-4 col-md-6 footer-about">
              <Link href="/" className="logo d-flex align-items-center">
                <span className="sitename">Smart Service</span>
              </Link>
              <div className="footer-contact pt-3">
                <p>F-14, Saket Business Hub,</p>
                <p>Radhanpur Road, Mehsana - 384002</p>
                <p className="mt-3">
                  <strong>Phone:</strong> <span>+91 8320443494</span>
                </p>
                <p>
                  <strong>Email:</strong> <span>info@smartservice.ind.in</span>
                </p>
              </div>
              <div className="social-links d-flex mt-4">
                <a href="#"><i className="bi bi-twitter-x"></i></a>
                <a href="#"><i className="bi bi-facebook"></i></a>
                <a href="#"><i className="bi bi-instagram"></i></a>
                <a href="#"><i className="bi bi-linkedin"></i></a>
              </div>
            </div>

            {/* Useful Links */}
            <div className="col-lg-3 col-md-4 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li><i className="bi bi-chevron-right"></i> <a href="#hero">Home</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#about">About us</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#services">Services</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of service</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy policy</a></li>
              </ul>
            </div>

            {/* Services */}
            <div className="col-lg-3 col-md-4 footer-links">
              <h4>Our Services</h4>
              <ul>
                <li><i className="bi bi-chevron-right"></i> <a href="#services">Tender-Based Manpower Supply</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#services">Technical & Engineering Staff Supply</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#services">Facility & Support Staffing</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#services">Security & Guard Services</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#services">Industrial & Construction Labor</a></li>
                <li><i className="bi bi-chevron-right"></i> <a href="#services">Contract & Temporary Staffing</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="copyright">
        <div className="container text-center">
          <p>
            © <span>Copyright</span>{' '}
            <strong className="px-1 sitename">Smart Service</strong>{' '}
            <span>All Rights Reserved</span>
          </p>
          <div className="credits">
            Developed by Ankit Prajapati
          </div>
          {/*<a href="https://storyset.com/work">Work illustrations by Storyset</a>*/}
        </div>
      </div>
    </footer>
  );
}
